export enum ShareType {
  SHARE_PRODUCT = "SHARE_PRODUCT",
  SHARE_PRODUCTS = "SHARE_PRODUCTS",
  SHARE_MEDIA = "SHARE_MEDIA",
  SHARE_MEDIAS = "SHARE_MEDIAS",
  SHARE_CATALOG = "SHARE_CATALOG",
}
